import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"


export const Achievement = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
};

return (
    <section className="achievement" id="achievement">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="achievement-bx wow zoomIn">
                        <h2>Achievements</h2>
                        <ul>
                            <li>Winner in Monthly Competitive Coding challenge in platform Geeks For Geek organized by official coding club of RCCIIT</li>
                            <li> Finalist of Smart Bengal Hackathon 2023 organized by RCC Institute Of Information Technology, Kolkata</li>
                            <li> Organized 2 Competitive Coding Competition (Cipher) in RCC Institute Of Information Technology, Kolkata</li>
                            <li> 6481 rank in Google Kickstart 2022</li>
                            <li>5 Star in Python, HackerRank</li>
                            <li> 4 Star in C, HackerRank</li>
                            <li>Convenor of Official Coding Club of RCC Institute Of Information Technology, Kolkata</li>
                            <li>Member of Women Techmakers</li>
                            
                        </ul> 
                        
                        {/*
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5>Brand Identity</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5>Logo Design</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>React.js</h5>
                            </div>
</Carousel>    */}
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}